<div >

<div style="position:relative; z-index: 100; width: 100%;">
<nav class="navbar navbar-expand-md pt-0 " style="position: fixed; width: 100%;">
  <div class="container">
    <a class="navbar-brand" [routerLink]="['']"><img class="lozad" src="assets/img/rev00.png"> </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse ms-md-4" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" [routerLink]="['']">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/about']">About Us</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/network']">Network</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/digital']">Digital Tribe</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
</div>

<!----end navbar--->

<!---HERO SECTION---->


<section>
	<div class="hero  position-relative overflow-hidden">
		<div class="welcome" >
			<h1 data-aos="fade-up" class="d-flex align-items-center gap-3 justify-content-center">

			Freedom 00 Presents: Revolution</h1>
			<p data-aos="fade-up" class="fw-bold">Community is Revolution: "We Stand on Business"</p>
		</div>
		<div class="shad position-absolute"></div>
			<div class="blur">
				<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1024 1024"><path fill="#fff" d="M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7" stroke-width="25.5" stroke="#fff"/></svg>
			</div>
	</div>
</section>

<!---END HERO SECTION---->

<!---REVOLUTION SECTION---->

<section>
	<div class="resident  pt-5">
		<div class="container">
			<div class="row">
				<div class="col-lg-6">
					<div class="tribe mt-md-5">
						<h3 class="purple"><span class="dark-blue">Welcome to the</span>  Revolution</h3>
						<p data-aos="fade-up" class="aos-init">Each digital gated community within UMYO Wallstreet of Technology is designed with its own unique set of guiding principles — and <b>Revolution 00</b> stands firm on a foundation of zero tolerance for negativity in any form. This space is intentionally built to uplift, protect, and empower those who are committed to growth, purpose, and collective elevation. We are not just building a digital ark in preparation for the AI storm— we are cultivating a thriving ecosystem, a purposeful hub, and a resilient community where only forward-minded, positive energy is welcomed. If you're here, you're here to rise.</p>
						<p data-aos="fade-up" class="aos-init"><b>Revolution-00</b> is an exclusive, gated social network created by us, for us. For just $9.99/month, you’ll become part of a powerful movement focused on empowerment, education, and economic elevation within the Black community.</p>
					</div>
				</div>
				<div class="col-lg-6">
					<div class="com-back h-100 " data-aos="zoom-in-down">
					<img class="img-fluid lozad" src="assets/img/Website_Images/1st.jpg">
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="owner py-5">
		<div class="container">
			<div class="row">
				<div class="col-lg-6">
				<div class="organ-img" data-aos="zoom-in-down">
					<img class="img-fluid lozad" src="assets/img/Website_Images/2nd.jpg">
				</div>					
				</div>
				<div class="col-lg-6">
					<div class="organization">
						<h1 class="purple aos-init aos-animate" data-aos="fade-up"><span class="dark-blue">Now introducing a </span>game-changing opportunity:</h1>
						<p data-aos="fade-up" class="aos-init"> For just $19.99, businesses can be marketed directly by our members, sold to a targeted audience, and invited to collaborate with those who are truly committed to supporting the Revolution. This is more than exposure — it's a direct path to authentic engagement and lasting growth.</p>
						<p data-aos="fade-up" class="aos-init">Each month, businesses within the <b>Revolution 00</b> ecosystem have the unique opportunity to give back to their local community by offering a prize giveaway, gift card, or product—directly to the residents who support them. These generous contributions aren’t just giveaways; they’re acts of love that help restore trust, unity, and connection within our gated digital community. </p>
						<p data-aos="fade-up" class="aos-init">Every participating business is proudly recognized during our live daily giveaway broadcast, shining a spotlight on their brand while reinforcing their commitment to local empowerment. It’s more than promotion—it’s purposeful presence. Together, we’re bringing the gift of love back into our neighborhoods, one prize at a time, and creating a cycle of gratitude, visibility, and growth that benefits everyone involved.</p>
						<strong data-aos="fade-up" class="mb-4 d-block ">Join the Revolution. Elevate your voice. Empower your vision. </strong>
						<a href="https://forms.gle/PFoTcEzW38zXaFKP8" target="_Blank" class="btn btn-hover-purple  border-dark  gap-2 mt-4" data-aos="fade-up">
							Enter Giveaway
					</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!---END REVOLUTION SECTION---->

<!----END COMMUNITY SECTION--->
<section>
	<div class="community">
		<div class="container">
			<div class="row">
				<div class="col-md-6">
				<div class="voice p-4">
					<h1 data-aos="fade-up">Our Voices. Unshaken. Unstoppable</h1>
					<div class="main d-flex align-items-center justify-content-between my-5">
						<div class="first" data-aos="fade-up">
							<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24"><path fill="#000" d="M21 21H3a1 1 0 0 1-1-1v-7.513a1 1 0 0 1 .343-.754L6 8.544V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1M9 19h3v-6.058L8 9.454l-4 3.488V19h3v-4h2zm5 0h6V5H8v2.127c.234 0 .469.082.657.247l5 4.359a1 1 0 0 1 .343.754zm2-8h2v2h-2zm0 4h2v2h-2zm0-8h2v2h-2zm-4 0h2v2h-2z"/></svg>
							<span class="d-block mt-3">Community</span>
						</div>
						<div class="second" data-aos="fade-up">
							<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 32 32"><path fill="#000" d="M12.558 15.254a4.28 4.28 0 0 0 4.277-4.28a4.277 4.277 0 1 0-8.557.002a4.28 4.28 0 0 0 4.28 4.278m3.104-.03a5.23 5.23 0 0 1-3.103 1.03a5.24 5.24 0 0 1-3.106-1.03c-.75.625-1.498 1.52-2.11 2.623c-1.423 2.563-1.58 5.192-.35 5.874c.55.313 1.126.08 1.722-.495a10.6 10.6 0 0 0-.166 1.873c0 2.938 1.14 5.312 2.543 5.312c.846 0 1.265-.865 1.466-2.188c.2 1.31.62 2.188 1.46 2.188c1.397 0 2.545-2.375 2.545-5.312c0-.66-.062-1.29-.167-1.873c.598.574 1.174.812 1.725.496c1.228-.68 1.07-3.31-.353-5.873c-.61-1.105-1.358-1.998-2.108-2.623zm4.16-11.513l-1.415 1.415a8.263 8.263 0 0 1 0 11.704l1.413 1.41a10.25 10.25 0 0 0 3.015-7.264c0-2.834-1.152-5.404-3.014-7.265zm-3.534 10.997L17.7 16.12c1.32-1.317 2.136-3.137 2.136-5.144S19.02 7.15 17.702 5.83l-1.414 1.415a5.27 5.27 0 0 1 0 7.462zM21.94 1.59l-1.41 1.414a11.24 11.24 0 0 1 3.307 7.97c0 3.11-1.265 5.93-3.308 7.973l1.413 1.414a13.23 13.23 0 0 0 3.895-9.385c0-3.66-1.49-6.98-3.894-9.385z"/></svg>
							<span class="d-block mt-3">Speak</span>

						</div>
						<div class="third" data-aos="fade-up">
							<svg xmlns="http://www.w3.org/2000/svg"  fill="#000" viewBox="0 0 16 16">
							  <path d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 1 1 .908-.418A6 6 0 1 1 8 2v1z"/>
							  <path d="M8 0a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2A.5.5 0 0 1 8 5V.5A.5.5 0 0 1 8 0z"/>
							</svg>
							<span class="d-block mt-3 ">Drive Change</span>
						</div>
					</div>
					<a style="background-color: white; color: black;" class="btn btn-hover-blue"  href="digital_community.html" data-aos="fade-up">
						Learn More
					</a>
				</div>
			</div>
			<div class="col-md-6">
				<div class="digital ps-md-4" >
					<h3 data-aos="fade-up"><b>Revolution-00</b>: Digital Onboarding for Community Investing
          Powered by Us. Protected by Purpose.</h3>
					<p data-aos="fade-up"><b>Revolution-00</b> is more than a social platform — it’s a digital movement designed to empower the Black community and those who truly support it. Our onboarding system makes it easy for residents and allies to <b>invest directly into gated communities</b> aligned with their passions and values.</p>
					<p data-aos="fade-up">Through this innovative model, members can take part in building and protecting local ecosystems — all while gaining access to <b>exclusive benefits like daily prize giveaways</b>, priority opportunities, and meaningful connections.</p>
					<p data-aos="fade-up">This isn’t just a membership — it’s <b>ownership, empowerment, and protection </b>from outside negativity. Every dollar, every decision, every connection stays rooted in the community.</p>
					<span data-aos="fade-up" class="text-white fw-bold">Revolution-00: Where community meets purpose, and support becomes power.</span>
					
				</div>
			</div>
			</div>
		</div>
	</div>
</section>
<!----END COMMUNITY SECTION--->
<!---- BUSINESS OWNER SECTION--->

<section>
	<div class="owner py-5">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-9 pb-5">
					<div class="business">
					<h1 data-aos="fade-up"><b>Revolution-00</b> for Businesses: You Can’t Afford to Miss This.</h1>
					<p data-aos="fade-up"><b>Revolution-00</b>, powered by UMYO Wallstreet of Technology, is where businesses meet the heart of the community. This isn’t just another directory—it’s a powerful digital hub that connects you directly with the people who drive your local economy.</p>
					<p data-aos="fade-up">Think of it as the future of networking: part Yellow Pages, part smart search engine, and part digital billboard—featuring interactive business cards that function like an upgraded Linktree. Whether you're a small startup or a legacy storefront, <b>Revolution-00</b> ensures you’re seen, supported, and trusted.</p>
					<p data-aos="fade-up">No time for marketing? No problem. Your community will amplify your brand, helping you grow through real engagement, word of mouth, and social trust. With built-in tools for eCommerce, funding, exposure, and collaboration, you’ll have everything you need to thrive—right at your fingertips.</p>
					<p data-aos="fade-up" class="fw-bold">Be discoverable. Be supported. Be part of the Revolution.</p>
					<div class="main secondmain d-flex align-items-center justify-content-between mt-5">
						<div class="first" data-aos="fade-right">
							<!-- Shopping Bag Icon -->
							<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 100 100"><path fill="#fff" d="M54.193 12.87c-.731 0-1.325.594-1.325 1.326c0 .068.029.127.039.193h-.039v31.438c0 .732.594 1.326 1.325 1.326H85.63v-.039c.066.01.125.039.194.039c.731 0 1.325-.594 1.325-1.326c-.188-18.12-14.836-32.768-32.956-32.957"/><path fill="#fff" d="M79.485 53.46c0-.732-.593-1.326-1.325-1.326H49.261a1.326 1.326 0 0 1-1.325-1.326V22.015h-.039c.01-.066.039-.125.039-.193c0-.733-.594-1.326-1.326-1.326c-.032 0-.058.016-.089.018v-.009c-.118-.001-.235-.009-.353-.009c-18.4 0-33.317 14.917-33.317 33.317S27.768 87.13 46.168 87.13s33.317-14.917 33.317-33.317q-.002-.158-.007-.318c0-.013.007-.023.007-.035"/></svg>

							<span class="d-block mt-3">Digital Marketplace</span>
						</div>
						<div class="second" data-aos="fade-up">
							<!-- Magnifying Glass Icon -->
							<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24"><path fill="#fff" d="M3.5 17.962q-.213 0-.356-.144Q3 17.674 3 17.46t.144-.356t.356-.144h8.558q.212 0 .356.145t.144.356t-.144.356t-.356.144zm0-4.789q-.213 0-.356-.144Q3 12.885 3 12.673q0-.213.144-.357t.356-.143h3.462q.212 0 .356.144t.144.357t-.144.356t-.356.143zm0-4.788q-.213 0-.356-.144Q3 8.097 3 7.884t.144-.356t.356-.143h3.462q.212 0 .356.144t.144.356t-.144.356t-.356.144zm10.423 6.634q-1.684 0-2.87-1.164T9.865 11.01t1.188-2.845T13.928 7t2.869 1.165Q17.981 9.329 17.981 11q0 .667-.222 1.303q-.223.636-.648 1.159l3.535 3.477q.16.134.16.34t-.16.367q-.134.14-.34.14q-.208 0-.368-.14l-3.534-3.477q-.543.406-1.178.628q-.636.222-1.303.222m0-1q1.274 0 2.166-.875t.892-2.134t-.892-2.135T13.923 8t-2.166.875t-.892 2.135t.892 2.134t2.166.875"/></svg>
							<span class="d-block mt-3">Digital Search Engine</span>

						</div>
						<div class="third" data-aos="fade-up">
							<!-- Credit Card / Digital Card Icon -->
							<svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 16 16">
							  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H0V4zm0 2h16v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6zm2 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H2z"/>
							</svg>
							<span class="d-block mt-3">Digital Cards advertising your business</span>
						</div>
						<div class="forth" data-aos="fade-left">
							<!-- Bar Chart / Analytics Icon -->
							<svg xmlns="http://www.w3.org/2000/svg"  fill="#fff" viewBox="0 0 16 16">
							  <path d="M0 0h1v15h15v1H0V0zm6 11V6h2v5H6zm3-2V4h2v5H9zm3-4V2h2v3h-2z"/>
							</svg>

							<span class="d-block mt-3">Google Analytics</span>
						</div>
					</div>
					<!-- <a href="https://www.youtube.com/watch?v=GveTikb8AAU" target="_blank" class="btn btn-hover-purple  border-dark d-flex align-items-center gap-2 mt-5" data-aos="fade-up">
						<div class="under">
							<span class="text-up">Learn More</span>
							<span class="text-down">Learn More</span>
						</div>
						<div class="d-flex position-relative overflow-hidden arrow">
							<svg class="black-arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1" viewBox="0 0 16 16">
							  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"></path>
							</svg>
							<svg class="white-arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="12" color="white" fill="none" stroke="currentColor" stroke-width="1" viewBox="0 0 16 16">
							  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"></path>
							</svg>
						</div>
					</a> -->
			      </div>
				</div>
			</div>
		</div>
	</div>
</section>
<!----END BUSINESS OWNER SECTION--->

<!----Organizations & Influencers SECTION--->

<section >
	<div class="power">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-6 ">
					<div data-aos="zoom-in-down" class="corporation">
						<img  class="img-fluid lozad" src="assets/img/Website_Images/1(9).png" style="border-radius: 20px;">
					</div>
				</div>
				<div class="col-md-6">
					<div class="corporation position-relative px-md-4">
						<h2 data-aos="fade-up" class="text-white"><b>Revolution-00</b>: Powering the Organizations That Power the People</h2>
						<p data-aos="fade-up">For years, your members have stood behind the mission. Now, it’s time to build something that stands with them—with a platform that’s owned by the community, not outside corporations.</p>
						<p data-aos="fade-up">Through <b>Revolution-00</b> and UMYO Wallstreet of Technology, unions and organizations with 5,000+ members can now launch their own exclusive, secure digital ecosystem—a private space where your members can connect, collaborate, and raise capital together in real time.</p>
						<p data-aos="fade-up">No more renting space on platforms that harvest your data and return zero value. This is about ownership, engagement, and legacy. Whether you represent a union, HBCU, fraternity, sorority, nonprofit, military group, university, or trade network, Revolution-00 gives you the tools to:</p>
						<ul class="ps-3" data-aos="fade-up">
							<li>Monetize your membership</li>
							<li>Re-engage inactive supporters</li>
							<li>Brand your mission from within</li>
							<li>And build lasting value—together</li>
						</ul>
						
					</div>
				</div>
			</div>
		</div>
	</div>
</section>



<!----END Organizations & Influencers SECTION--->

<!----work SECTION--->
<section>
	<div class="works">
		<div class="container">
		<h3 class="ms-3" data-aos="fade-up">How It Works?</h3>
			<div class="row">
				<div class="col-md-4 mb-md-0 mb-3">
				<div class="p-3 comp h-100" data-aos="fade-right">
				   <h2 >
				   	Private & Safe Digital Communities
				   </h2>
				   <p>Each union/organization will have its own exclusive digital platform tailored for its members, offering secure private networking.</p>
				</div>					
				</div>
				<div class="col-md-4 mb-md-0 mb-3">
					<div class="p-3 comp h-100" data-aos="fade-up">
				   <h2>
				   	Comprehensive Services
				   </h2>
				   <p>Our tech firm will handle all maintenance, hosting, tech support, and day-to-day updates, allowing your union to focus on its core mission.</p>
				</div>
				</div>
				<div class="col-md-4 mb-md-0 mb-3">
					<div class="p-3 comp h-100" data-aos="fade-left">
				   <h2>
				   	Revenue Sharing
				   </h2>
				   <p>UMYO shares up to 15% of membership fees with the org/union and up to 15% with its members, creating a sustainable financial model.</p>
				</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!----END work SECTION--->

<!---- CARDS SECTION--->
<section>
	<div class="packages">
		<div class="container">
			<div class="row">
				<div class="col-md-4 mb-lg-0 mb-3">
					<div class="membership-cards h-100" data-aos="fade-right">
						<div class="card " >
						<h2 >Free</h2>
						<ul class="">
							<li>1 Digital Card</li>
							<li>1 Product Listing</li>
							<li>Digital card access</li>
						</ul>						
					</div>
					</div>
				</div>
				<div class="col-md-4  mb-lg-0 mb-3">
					<div class="membership-cards h-100" data-aos="fade-up">
					  <!-- Card 1 -->
					  <div class="card">
					    <h2>Official Launch Special</h2>
					    <p class="price">$9.99 <span>Lifetime</span></p>
					    <p><strong>First 5k Members Only</strong></p>
					    <ul>
					      <li>5 Digital Cards</li>
					      <li>3 Images</li>
					      <li>2 Videos</li>
					      <li>Social Media Links</li>
					      <li>Digital Community Access</li>
					    </ul>
					  </div>
					</div>
				</div>
				
				<div class=" col-md-4 mb-lg-0 mb-3">
					<div class="membership-cards" data-aos="fade-left">
					<!-- Card 2 -->
					  <div class="card">
					    <h2>Official Launch Special</h2>
					    <p class="price">$19.99 <span>Monthly</span></p>
					    <p><strong>First 5k Members Only (Great for Business Owners)</strong></p>
					    <ul>
					      <li>20 Digital Cards</li>
					      <li>3 Images</li>
					      <li>Logo</li>
					      <li>20 Videos</li>
					      <li>Social Media Links</li>
					      <li>Digital Community Access</li>
					    </ul>
					  </div>
					</div>
				</div>
			<div class="col-md-12">
				<p class="note">
				  <strong>Note:</strong> Members become eligible for weekly prize giveaways after 90 days. The bigger your monthly package, the more shine you get — with extra visibility, branding, and community support to boost those giveaway chances.
				</p>
			</div>
		</div>
		</div>
	</div>
</section>
<!----END CARDS SECTION--->

<!----LOGO SLIDER SECTION--->

<div class="slider  overflow-hidden" id="logos">
  <div id="gallery1" class="mx-md-0 mx-3">
    <div class="slide">	
     <a href="https://R00appointments.site " target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_appointments.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://R00dating.site/public" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_dating.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://R00estore.site" target="_Blank">
      	<img class="lozad" src="assets/img/Strolling_Images/r00_estore.png" alt="">
      </a>
    </div>
    <div class="slide">
      <a href="https://R00events.site" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_events.png" alt=""></a>
    </div>
    <div class="slide">
    <a href="https://R00fans.site" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_fans.png" alt="">
    </a>      
     </div>
    <div class="slide">
      <a href="#" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_games.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://R00livestream.site" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_livestream.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://R00music.site" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_music.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://R00radio.site" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_radio.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://R00talks.site" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_talks.png" alt=""></a>
    </div>
</div>

<div id="gallery" dir="rtl">
    <div class="slide">
      <a href="https://R00thinktribe.site" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_thinktribe.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://R00tweets.site" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_tweets.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="#" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_vpn.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://R00livestream.site" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/r00_livestream.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://highschooltalks.site" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/R00_Youth_Minded.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="#" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/Prize_Giveaways.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://umyobiz.com/DFW21" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/Coupon_Booklet.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://umyobiz.com/HairMag1" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/video_magazine.png" alt=""></a>
    </div>
    <div class="slide">
      <a href="https://r00news.site" target="_Blank"><img class="lozad" src="assets/img/Strolling_Images/R00_news.png" alt=""></a>
    </div>
</div>
</div>
<!----END LOGO SLIDER SECTION--->

<section class="py-5" id="faq">
	<div class="container">
		<div class="row justify-content-center">
				<div class="col-lg-10 ">
					<h3 class="fa-3x text-white text-center call" data-aos="fade-up">Welcome to the <b>Revolution 00</b> HBCU & Organizations Inbound/Outbound Call Center</h3>
					<p class="text-center  academy" data-aos="fade-up">Powered by the <b>Revolution 00</b> Digital Community</p>
				</div>
				<div class="col-lg-9 mb-5">
					<p class="text-center grow" data-aos="fade-up">Looking to grow your brand and make a difference? At <b>Revolution 00</b> call center, youth, parents, and local organizations work together to help businesses like yours connect, thrive, and gain powerful online exposure.</p>
					<p class="text-center grow" data-aos="fade-up">When you call in to register your business on <a href="Revolution00.com">Revolution00.com</a>.com, our team of youth, parents and organization personally walks you through the sign-up process. Once you're in, youth and families in our network promote your brand across social media based on your budget—making sure your message reaches the right audience.</p>
					<p class="text-center grow" data-aos="fade-up"><b>Half of every dollar goes directly to students, families, and partner organizations</b>, supporting education, employment, and community growth monthly.<br>
						It's not just marketing—it's mission-driven marketing.
 					<b>A service for a service.</b></p>

				</div>
			</div>
			<div class="row" style="margin-top: 70px;">
    <div class="col-12">
        <h2 class=""><b>Revolution 00</b> - We Stand On Business</h2>
        <h4 class=" mt-5 mb-3">We Stand On Business <br>Frequently Asked Questions</h4>
        <div class="accordion" id="accordionExample">
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        How do we take back our communities?
                    </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        We, as a unified unit, must recognize the influence of technology and collectively shift towards platforms that not only support community concerns financially but also uphold principles of free speech. Until each of us makes a personal commitment to this cause, we cannot stand together effectively to address community issues. Now that you know this, the question now becomes, are you as an individual contributing to the negativity or the positivity of the influence of social media?
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Does this mean we jump ship from our other platforms?
                    </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        No, we are simply recommending a transition of your content to both. You can also share from<b> Revolution 00</b> digital ark platforms to most of the existing popular platforms. As more people begin to realize why community-owned platforms are the new "it factor," you will have already educated and migrated your subscribers and followers to a vessel that isn't the Titanic. If, by chance, you choose not to migrate, there's a risk of losing everything during the AI storm that is approaching us. At Umyo, you are registered on digital arks based upon interest.<b> Security, privacy and Accountability.</b>
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Is Revolution 00 UMYO Nubian/Black-Owned?
                    </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <b>Revolution 00</b> was founded by a Nubian father and his three sons. It is a community-owned initiative based on the principle that no single ethnicity can solve community concerns alone. We welcome individuals from all backgrounds who are aligned with our mission: to utilize community-owned platforms to uplift and serve the needs of all communities.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingfour">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefour" aria-expanded="false" aria-controls="collapsefour">
                        Is my Data Private?
                    </button>
                </h2>
                <div id="collapsefour" class="accordion-collapse collapse" aria-labelledby="headingfour" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Yes. Your data is kept private. We only collect essential contact information like your name and email—similar to a business card. You may optionally include social media links and a business address for others to contact or find your establishment. We do not ask for any other personal information. Daily giveaway prizes can be shipped to the business address provided during registration.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingfive">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefive" aria-expanded="false" aria-controls="collapsefive">
                        Do you save or store credit card information?
                    </button>
                </h2>
                <div id="collapsefive" class="accordion-collapse collapse" aria-labelledby="headingfive" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        No. We use trusted third-party gateways like PayPal and Stripe. Your payment details are encrypted and processed securely by these gateways. <b>Revolution 00</b> only receives confirmation of the payment—not your sensitive financial information. 
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingsix">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsesix" aria-expanded="false" aria-controls="collapsesix">
                        Revolution 00 platforms free?
                    </button>
                </h2>
                <div id="collapsesix" class="accordion-collapse collapse" aria-labelledby="headingsix" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        No, they are not free. Your membership supports daily prize giveaways and community-driven initiatives. The more members who join, the more we can give back. This movement is built on The <b>IAM Pledge</b>, which encourages reporting violent crimes in our communities and supports accountability across all individuals and businesses. <br><br>
                        Other platforms may seem free, but they cost us our mental health, self-worth, and peace of mind. With <b>Revolution 00</b>, you're joining a <b>digital gated community</b> built around shared interests, positivity, and fewer trolls. <br><br>

                        Membership fees:
                        <ul>
                            <li><b>Platforms</b> require a $9.99/month membership.</li>
                            <li><b>Platforms</b> require a $19.99/month membership for Businesses</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingseven">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseseven" aria-expanded="false" aria-controls="collapseseven">
                        What do you mean by "social media programming"?
                    </button>
                </h2>
                <div id="collapseseven" class="accordion-collapse collapse" aria-labelledby="headingseven" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Many of us stay on harmful platforms because we believe there's no positive alternative. But when community-owned platforms arise and give back half of their profits to address real concerns—why are we still stuck? Are we conditioned to tolerate abuse? Is it pride? Fear? Programming?<br><br>
                        <ul>
                            <li>Are we truly making a difference when 98% of what we see is negative?</li>
                            <li>Why do people stay if they're not getting paid?</li>
                            <li>If they are paid, isn't it because we're all still participating?</li>
                        </ul>
                        <br>
                        This is systematic programming—digital plantations for all backgrounds. How long will we stay?
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingeight">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseeight" aria-expanded="false" aria-controls="collapseeight">
                        How does Revolution 00 contribute to solving community concerns?
                    </button>
                </h2>
                <div id="collapseeight" class="accordion-collapse collapse" aria-labelledby="headingeight" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        By allocating % <b>of profits</b> to community initiatives, we fund real change. Individual memberships range from $9.99–$19.99/month. These funds support giveaways, branding services, and round-the-clock access to our virtual hubs. Together, this collective investment builds stronger, solution-focused communities<br><br> 

                        We've emotionally bankrupt ourselves for years on toxic platforms—it's time to <b>invest in ourselves and each other. Revolution 00</b> is building safe digital communities for those still awake, while praying for the lost. This isn't just social media. It's <b>a movement</b>.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingten">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseten" aria-expanded="false" aria-controls="collapseten">
                        What does it mean that Revolution 00 provides up to eight platforms per digital ark/tribe?
                    </button>
                </h2>
                <div id="collapseten" class="accordion-collapse collapse" aria-labelledby="headingten" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Each tribe/hub caters to a specific community (e.g., Military, DFW, ATL, Hair N Beauty, Realtors, Restaurants). Within each tribe, users gain access to 8+ customized platforms, including:<br>
                        <ul>
                            <li>Virtual conferencing (like Zoom)</li>
                            <li>Social media (like Facebook)</li>
                            <li>Tweet-like short posts</li>
                            <li>Real-time messaging and networking</li>
                        </ul>
                        <br>
                        This creates an ecosystem tailored for <b>positive collaboration, growth, and connectivity</b>—without the toxicity of mainstream platforms.
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingeleven">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseeleven" aria-expanded="false" aria-controls="collapseeleven">
                        What sets Revolution 00 apart from competitors?
                    </button>
                </h2>
                <div id="collapseeleven" class="accordion-collapse collapse" aria-labelledby="headingeleven" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Everything.<br>
                        We're the only platform where:
                        <ul>
                            <li>The community does the marketing for you.</li>
                            <li>You can search digital cards by name, business, school, GPA, athletic rank, and more.</li>
                            <li>Members can befriend, chat, network, and share directly.</li>
                            <li>Giveaways are funded by the community, for the community.</li>
                            <li>Your profile includes virtual conferences, tweet boards, social walls, and 24/7 live streams.</li>
                        </ul>
                        <br>
                        Our platform is built by the people—for the people—not by massive corporations. We partner with organizations with 5,000+ members and return <b>30%</b> of profits to them, while handling the backend so they can focus on their mission.<br><br>
                        We don't believe politics should divide us—we believe unity is the 3rd option. Choose a path forward. Choose to build something we can believe in. 
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingtwelve">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsetwelve" aria-expanded="false" aria-controls="collapsetwelve">
                        How do we register?
                    </button>
                </h2>
                <div id="collapsetwelve" class="accordion-collapse collapse" aria-labelledby="headingtwelve" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <ul>
                            <li>Go to the <b>Directories</b> section at the top of the homepage.</li>
                            <li>Choose the directory that fits your interest.</li>
                            <li>Click <b>"Registration."</b></li>
                            <li>Complete the form and choose a package.</li>
                            <li>Pay securely through our encrypted gateway.</li>
                            <li>Check your email (and spam folder) for your private code.</li>
                            <li>Enter the code when prompted to complete the process.</li>
                        </ul>
                        <br>
                        or visit:<a href="https://umyonetwork.com">https://umyonetwork.com</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
	</div>
</section>

<!----PLEDGE SECTION--->
<section>
	<div class="pledge">
		<div class="container">
			<div class="row" style="margin-top: 70px">
				<div class="col-lg-6">
					<div class="child">
						<h3 class="title" >
							<span>It Starts With</span> Us. The IAM Pledge.
						</h3>
						<p >Our communities thrive when we hold ourselves—and each other—accountable. That’s the heart of our digital platforms: to create safe, supportive spaces where every resident commits to something greater. By taking the IAM Pledge, you’re making a personal vow to report violent crimes, protect your neighborhood, and use your voice to uplift others.</p>
						<p >But safety is only part of the mission. These platforms are also a lifeline—for those facing silent battles. Through mental health awareness and access to supportive tools, we’re breaking the stigma, starting real conversations, and building a culture of compassion.</p>
						<p >Together, we can create communities that are not only connected—but courageous, informed, and deeply human. This is your platform. This is your pledge. IAM.</p>
					</div>
				</div>
				<div class="col-lg-6">
					<div class="child right" data-aos="flip-up">
						<i class="fa-solid fa-globe text fa-4x "></i>
						<h3 class="title text-center mt-3">The IAM Pledge</h3>
						<span class="text-center d-block">A Commitment to Community, Safety & Mental Wellness</span>
						<ul class="ps-3 mt-3">
							<li> I pledge to report violent crimes in my community.</li>
							<li> I pledge to stand up, speak out, and protect those around me.</li>
							<li>I pledge to use my voice to break the silence around mental health.</li>
							<li> I pledge to listen, support, and build up those who are struggling.</li>
							<li> I pledge to hold myself accountable—because healing starts with honesty.</li>
							<li> I pledge to be part of the solution, not the silence.</li>
						</ul>
					</div>
				</div>
				<div class="col-12 mt-5">
					<div class="line"></div>
				</div>
			</div>
	</div>
  </div>
</section>











</div>